import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,AiTwotoneMail
} from "react-icons/ai";
import {
  IoMdCall
} from "react-icons/io";

import { RiWhatsappFill } from "react-icons/ri";
import { FaLinkedinIn } from "react-icons/fa";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <Row>
        <Col md={12} className="home-about-social">
          <h1>CONTACT ME ON</h1>
          <p>
            Feel free to <span className="purple">connect </span>with me
          </p>
          <ul className="home-about-social-links contact-me">
            <li className="social-icons">
              <a
                href="https://github.com/amitmishra7488"
                target="_blank"
                rel="noreferrer"
                className="icon-colour  home-social-icons"
              >
                <AiFillGithub />
              </a>
            </li>

            <li className="social-icons">
              <a
                href="https://www.linkedin.com/in/amit-kumar-64b0871b8/"
                target="_blank"
                rel="noreferrer"
                className="icon-colour  home-social-icons"
              >
                <FaLinkedinIn />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="mailto:coolamitgolu567@gmail.com"
                target="_blank"
                rel="noreferrer"
                className="icon-colour  home-social-icons"
              >
                <AiTwotoneMail />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="tel:+917488078433"
                target="_blank"
                rel="noreferrer"
                className="icon-colour  home-social-icons"
              >
                <IoMdCall />
              </a>
            </li>
          </ul>
        </Col>
      </Row>
      <Row>
        <Col md="4" className="footer-copywright">
          <h3>Designed and Developed by Amit Kumar</h3>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
